import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import SearchForm from 'app/commons/components/SearchForm';
import { withGlobalData } from 'app/utils/withGlobalData';
import ListSinger from 'app/components/music/ListSinger';
import Paginate from 'app/commons/components/Paginate';
import ListMusic from 'app/components/music/ListMusic';
import * as commonActions from 'app/actions/commons';
import { buildParams } from 'app/utils/pagination';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import * as listenApi from 'app/requests/listens';
import { setNewParams } from 'app/utils/ga';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import storage from 'app/utils/storage';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

export default function Index({ musics, singers }) {
  const router = useRouter()
  const { t } = useTranslation();
  const defaultParam = {
    keyword: router.query.keyword || '',
    page: router.query.page || 1,
    type: router.query.type || 'all',
  };
  const dispatch = useDispatch();
  const [params, setParams] = useState(defaultParam);
  const [isChange, setIsChange] = useState(false);
  const [musicLove, setMusicLove] = useState(null);
  const [currentItem, setCurrentItem] = useState('all');
  const tasks = [
    { key: 'all', label: t('song.btn_all') },
    { key: 'singer', label: t('song.btn_singer') },
    { key: 'top', label: t('song.btn_top') },
    { key: 'love', label: t('song.btn_love') }
  ];

  useEffect(() => {
    if (isChange) pushUrl();
    setCurrentItem(params.type as string);
    setIsChange(true);
  }, [params]);

  const pushUrl = async () => {
    try {
      dispatch(commonActions.setLoading(true));
      setMusicLove(null);

      if (params.type !== 'love') {
        const url = `/song${buildParams(params)}`
        router.push(url, url)
      } else {
        let songIds = storage.get("songIds");
        songIds = songIds?.split(',') || [];
        const myLove = await listenApi.getSongs({ ...params, songIds, direction: 'asc', limit: 42 });
        setMusicLove(myLove);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(commonActions.setLoading(false));
    }
  }

  const onChangeItem = async (key: string) => {
    setCurrentItem(key);
    setDataParams(key, 'type', 1)
  }

  const setDataParams = (value: string | number, name: string, page: number | null = null) => {
    setNewParams(setParams, params, value, name, page);
  }

  const renderListItem = () => {
    const items = currentItem === 'singer' ? singers : (musicLove || musics);

    return (
      <div className="form-group mt-3">
        {items?.data?.length > 0 &&
          <div>
            {
              currentItem === 'singer' ? <ListSinger singers={items.data} />
                : <ListMusic musics={items.data} pushUrl={pushUrl} />
            }
            <Paginate
              data={items}
              handleChangePage={(page: number) => setDataParams(page, 'page')}
            />
          </div>
        }
        {!items?.data?.length &&
          <div className='text-danger text-center mt-3 text-size-xl'>
            {t('commons.result_notfound')}
          </div>
        }
      </div>
    )
  }

  return (
    <section id="songPage" className="box-card-area list-test overflow-hidden">
      <NextSeo
        title={t('song.title')}
        description={t('song.music_description')}
      />
      <div className="d-flex">
        <div className="box-news-area">
          <div className='content_inner'>
            <Title title='song.title' />
            <div className="text-center btn-song-top d-flex justify-content-center flex-wrap mt-3">
              <div className='mt-2'>
                {
                  tasks.map(item => {
                    return (
                      <button
                        type="button"
                        key={item.key}
                        style={{ minWidth: 80 }}
                        className={`m-1 btn btn-sm ${currentItem == item.key ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => onChangeItem(item.key)}
                      >
                        {item.label}
                      </button>
                    )
                  })
                }
              </div>
              <div className='position-relative col-md-5 px-3 px-md-1 pt-1 pt-md-0'>
                <SearchForm setDataParams={setDataParams} />
              </div>
            </div>
            <div className='mt-4'>
              {renderListItem()}
            </div>
          </div>
        </div>
        <RightContent />
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  try {
    const translationsPromise = serverSideTranslations(locale, ['common']);
    const dataPromise =
      query.type === 'singer'
        ? listenApi.getSingers({ ...query, direction: 'asc', limit: 60 })
        : listenApi.getSongs({ ...query, direction: 'asc', limit: 42 });

    const [translations, data] = await Promise.all([translationsPromise, dataPromise]);

    return {
      props: {
        ...translations,
        musics: query.type === 'singer' ? null : data,
        singers: query.type === 'singer' ? data : null,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});

